import * as React from 'react';

import { replaceElement } from '@lendi-jam/generic-rich-text';
import TextImageLayout from '@lendi-jam/text-image-layout';
import { useCommPanel } from '@lendi/navbar';
import parse from 'html-react-parser';

import { PrismicLink } from '#contentTypes/PrismicTypes';
import { TextImageLayoutContent } from '#contentTypes/TextImageLayout';

import { getButton } from '../lib/prismicFunctions';



interface PrismicTextImageLayoutProps {
  component: TextImageLayoutContent;
}

const PrismicTextImageLayout: React.FC<PrismicTextImageLayoutProps> = ({ component }) => {
  const { openChat } = useCommPanel();
  const TextImagePrimary = component.primary;
  const onClickChat = (e: React.SyntheticEvent | React.SyntheticEvent<Element, Event>) => {
    e.preventDefault();
    openChat();
  };

  const isChatLink = (link?: PrismicLink) => link?.url && link.url.includes('chat:open');

  const PrimaryButton = getButton(
    TextImagePrimary.primary_button_text,
    TextImagePrimary.primary_button_link,
    isChatLink(TextImagePrimary.primary_button_link) ? onClickChat : undefined
  );
  const SecondaryButton = getButton(
    TextImagePrimary.secondary_button_text,
    TextImagePrimary.secondary_button_link,
    isChatLink(TextImagePrimary.secondary_button_link) ? onClickChat : undefined
  );

  return (
    <TextImageLayout
      title={TextImagePrimary.layout_title.text}
      content={parse(TextImagePrimary.content?.html || '', {
        replace: (domNode) => replaceElement(domNode, 'shade.800'),
      })}
      primaryButton={PrimaryButton}
      secondaryButton={SecondaryButton}
      image={TextImagePrimary.image?.fluid}
      alt={TextImagePrimary.image?.alt || ''}
      variant={TextImagePrimary.layout_variant}
      colourVariant={TextImagePrimary.variant}
    />
  );
};

export default PrismicTextImageLayout;
